import React, { useEffect } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { Bar } from 'react-chartjs-2';
import { makeStyles } from '@material-ui/styles';
import {
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Divider,
  Button, CircularProgress
} from '@material-ui/core';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';

// import { data, options } from './chart';
import { Loading } from 'redux/Action';
import { useDispatch, useSelector } from 'react-redux';
import { axios } from './../../../../axios';
import palette from "theme/palette";

const useStyles = makeStyles(() => ({
  root: {},
  chartContainer: {
    height: 422,
    position: 'relative'
  },
  actions: {
    justifyContent: 'flex-end'
  }
}));

const EarningChart = props => {
  const { className, ...rest } = props;

  const classes = useStyles();


  const [dataBar, setDataBar] = React.useState([]);
  const [labelBar, setLabelBar] = React.useState([]);

  let numbers = [];
  let Labels = [];

  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.isLoading);
  const token = useSelector((state) => state.token);
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  function convertToMonth(n) {
    switch (n) {
      case 1:
        return "فروردین";
        break;
      case 2:
        return "اردیبهشت";
        break;
      case 3:
        return "خرداد";
        break;
      case 4:
        return "تیر";
        break;
      case 5:
        return "مرداد";
        break;
      case 6:
        return "شهریور";
        break;
      case 7:
        return "مهر";
        break;
      case 8:
        return "آبان";
        break;
      case 9:
        return "اذر";
        break;
      case 10:
        return "دی";
        break;
      case 11:
        return "بهمن";
        break;
      case 12:
        return "اسفند";
        break;
    }
  }



  async function GetData() {

    try{
      const res = await axios.get('dashboard', {
        headers: headers,

      });
      // console.log(res.data.shipments, "sssssss");

      let er = res.data.shipments;
        let er_keys = Object.keys(er);
        let obj_error = {};
        console.log(er," sss ")
        er.map((element) => {
          console.log(element,"elementelement")

          
          Labels.push(
            convertToMonth(
              Number(element?.dates.substring(element?.dates.length - 2, element?.dates.length))
            )
          );
          numbers.push(element?.count);
        });

        setLabelBar(Labels);
        setDataBar(numbers);
        dispatch(Loading());    }
    catch(e)
    {
      dispatch(Loading());

    }
 

  
  }




  useEffect(() => {
    dispatch(Loading());

    GetData();
  }, []);

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardHeader
        action={
          <Button
            size="small"
            variant="text"
          >
          6 ماهه گذشته 
          </Button>

        }
        title="بارهای اخیر"
      />
      <Divider />
      <CardContent>
        <div className={classes.chartContainer}>
        {!isLoading ? (
            <Bar
              data={{
                labels: labelBar,
                datasets: [
                  {
                    label: "تعداد کل بارها ",
                    backgroundColor: palette.primary.main,
                    data: dataBar,
                  },
                ],
              }}
              options={options}
            />
          ) : (
            <div
              style={{
                display: "flex",
                flex: 1,
                alignItems: "center",
                height: "100%",
                justifyContent: "center",
              }}
            >
              <CircularProgress size={24} />
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
};

EarningChart.propTypes = {
  className: PropTypes.string
};

export default EarningChart;
export const options = {
  responsive: true,
  maintainAspectRatio: false,
  animation: false,
  legend: {
    display: true,
    labels: {
      usePointStyle: true,
      fontFamily: "IranSans",
    },
  },
  cornerRadius: 10,
  tooltips: {
    enabled: true,
    titleFontFamily: "IranSans",
    titleFontSize: 15,
    rtl: true,
    bodyFontFamily: "IranSans",
    bodyFontSize: 15,
    mode: "index",
    intersect: false,
    borderWidth: 1,
    borderColor: palette.divider,
    backgroundColor: palette.white,
    titleFontColor: palette.text.primary,
    bodyFontColor: palette.text.secondary,
    footerFontColor: palette.text.secondary,
  },
  layout: { padding: 0 },
  scales: {
    xAxes: [
      {
        barThickness: 30,
        maxBarThickness: 32,
        barPercentage: 0.5,
        categoryPercentage: 0.5,
        ticks: {
          fontColor: palette.text.secondary,
          fontSize: 15,
          fontFamily: "IranSans",
        },
        gridLines: {
          display: false,
          drawBorder: false,
        },
      },
    ],
    yAxes: [
      {
        ticks: {
          fontColor: palette.text.secondary,
          beginAtZero: true,
          fontFamily: "IranSans",

          min: 0,
        },
        gridLines: {
          borderDash: [2],
          borderDashOffset: [2],
          color: palette.divider,
          drawBorder: false,
          zeroLineBorderDash: [2],
          zeroLineBorderDashOffset: [2],
          zeroLineColor: palette.divider,
        },
      },
    ],
  },
};
